import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=7c9a5283&scoped=true&"
import script from "./VideoElement.vue?vue&type=script&lang=ts&"
export * from "./VideoElement.vue?vue&type=script&lang=ts&"
import style0 from "./VideoElement.vue?vue&type=style&index=0&id=7c9a5283&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9a5283",
  null
  
)

export default component.exports